module.exports = __webpack_public_path__ + "img/message.1a5a45e2.png";